import injectSheet from 'react-jss'
import CustomField from './CustomField'
import styles from './CustomField.styles'

export default injectSheet(styles)(CustomField)
